<template>
  <div class="w-full bg-white shadow-sm rounded-lg border border-gray-200 flex flex-col">
    <button 
      @click="isOpen = !isOpen"
      class="w-full px-4 py-3 flex justify-between items-center focus:outline-none"
    >
      <span class="text-teal-900 text-sm font-semibold uppercase tracking-wider text-left">
        <Translation v-if="titleKey" :name="titleKey" :default="title" />
        <template v-else>{{ title }}</template>
      </span>
      <svg 
        :class="{'rotate-180': isOpen}" 
        class="w-5 h-5 text-teal-900 transition-transform duration-200" 
        fill="none" stroke="currentColor" viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <div v-show="isOpen" class="px-3 pb-3 flex flex-col gap-1">
      <label 
        v-for="option in options" 
        :key="option"
        class="flex items-center gap-3 px-3 py-2 hover:bg-gray-50 rounded-md cursor-pointer transition-colors relative"
      >
        <input 
          type="checkbox" 
          :value="option"
          v-model="selectedValues"
          class="absolute opacity-0 w-0 h-0"
        >
        
        <div class="inline-flex justify-center items-center flex-shrink-0">
          <div 
            :class="[
              'w-5 h-5 rounded-[6px] flex items-center justify-center transition-colors',
              selectedValues.includes(option) 
                ? 'bg-teal-800 outline outline-1 outline-offset-[-1px] outline-teal-800' 
                : 'bg-white border border-[#D5D7DA]'
            ]"
          >
            <CheckboxIcon v-if="selectedValues.includes(option)"></CheckboxIcon>
          </div>
        </div>
        <span class="text-gray-700 text-sm">{{ option }}</span>
      </label>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import CheckboxIcon from "../icons/CheckboxIcon.vue";

const props = defineProps({
  title: String,
  titleKey: String,
  options: Array,
  modelValue: Array
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(false);

const selectedValues = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
});
</script>